import { useEffect, useState } from "react";

export const useShowNewCheckoutExperienceDesktop = () => {
  const [showNewCheckout, setShowNewCheckout] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const abTastyTime =
      typeof process !== "undefined" && process?.env?.GATSBY_ABTASTY_SET_TIMEOUT
        ? parseInt(process.env.GATSBY_ABTASTY_SET_TIMEOUT)
        : 400;

    // Initial check
    const envFlag =
      process.env.GATSBY_SHOW_NEW_CHECKOUT_EXPERIENCE_DESKTOP === "true";
    const sessionFlag = sessionStorage.getItem(
      "HIDE_NEW_CHECKOUT_EXPERIENCE_DESKTOP"
    );
    setShowNewCheckout(envFlag && sessionFlag !== "true");

    // Re-check after short delay in case AB Tasty updated sessionStorage
    const timeout = setTimeout(() => {
      const latestSessionFlag = sessionStorage.getItem(
        "HIDE_NEW_CHECKOUT_EXPERIENCE_DESKTOP"
      );
      setShowNewCheckout(envFlag && latestSessionFlag !== "true");
    }, abTastyTime); // 300ms gives AB Tasty time to set the flag

    return () => clearTimeout(timeout);
  }, []);

  return showNewCheckout;
};
